export const moneyStringToFloat = (value) => {
    if (null === value || undefined === value || '' === value) {
        return 0.0;
    }

    switch (typeof value) {
        case 'number':
            return value;
        case 'string':
            return parseFloat(value.replaceAll(' ', '').replaceAll(',', '.'));
    }

    return NaN;
};

export const formatStringToZusMoney = (value) =>
    hubIntlNumberFormat
        .format(value)
        .replaceAll(/\s/g, '');

const formatStringToHubMoney = (value, formatter) => {
    formatter = formatter || hubIntlNumberFormat;

    return formatter
        .format(value)
        .replaceAll(/\s/g, ' ')
        .replace(/^(-?\d)(\d{3}(,\d{2})?)$/, '$1 $2');
};

export const moneyFormatToSting = (value, formatter) => {
    if (null === value || undefined === value) {
        return value;
    }
    switch (typeof value) {
        case 'number':
            return formatStringToHubMoney(value, formatter);
        case 'string':
            return formatStringToHubMoney(moneyStringToFloat(value), formatter);
    }

    return NaN;
};

export const isPositive = (value) => {
    if (null === value || undefined === value) {
        return false;
    }
    switch (typeof value) {
        case 'number':
            return value > 0;
        case 'string':
            return moneyStringToFloat(value) >= 0;
    }
}
